// inputタグのtypeで検索
export function getElementByType(typeName: string): HTMLInputElement | undefined {
  const inputs = document.getElementsByTagName('input');
  for (let i = 0; i < inputs.length; i++) {
    if (inputs[i].type === typeName) {
        return inputs[i];
    }
  }

  return undefined;
}

// イベントさせない
export function returnFalse(): boolean {
  return false;
}

export const JS_VOID: string = 'javascript: void(0);';

export const RETURN_FALSE: string = 'return false;';

// ログイン済みならメニュー表示、未ログインならログイン画面に遷移するページのURL.
export const LOGIN_URL: string = '/admin.html';

/**
 * Base64に変換.
 *
 * @export
 * @param {*} origin 元の値.
 * @returns {string} Base64の文字列.
 */
export function encodeBase64(origin: any): string {
  const objJsonStr = JSON.stringify(origin);
  const objJsonB64 = Buffer.from(objJsonStr).toString('base64');
  return objJsonB64;
}

/**
 * Base64から戻す.
 *
 * @export
 * @param {string} encodedData Base64の文字列.
 * @returns {string} 元の値.
 */
export function decodeBase64(encodedData: string): string {
  const moji = new Buffer(encodedData, 'base64').toString('utf-8', 0, encodedData.length);
  const objJsonStr = JSON.parse(moji);
  return objJsonStr;
}

/**
 * クエリ文字列を変換する.
 *
 * @export
 * @param {string} query
 * @returns
 */
export function parseQueryString(query: string) {
  let obj = Object.create(null);
  query.slice(query.indexOf('?') + 1, query.length).split('&').map(entry => {
    Object.assign(obj, {
      [entry.split('=')[0]]: entry.split('=')[1]
    });
  });
  return obj;
}

/**
 * Canvasの縦横サイズを0にしてメモリ解放する.
 *
 * @export
 * @param {((HTMLCanvasElement | null)[])} [refCharts=[]]
 * @returns
 */
export function memoryReleaseForCanvas(refCharts: (HTMLCanvasElement | null)[] = []) {
  // 縦横サイズを0にしてcanvasを開放する.
  for (let i = 0; i < refCharts.length; i++) {
    let chart = refCharts[i];
    if (chart !== null && typeof(chart) !== 'undefined') {
      // Get canvas context
      const context1 = chart.getContext('2d');
      if (context1 === null) {
        return;
      }
    
      context1.canvas.width = 0;
      context1.canvas.height = 0;
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/commonUtil.tsx